import { useMemo } from 'react';

import { FeatureCard } from './Feature';
import { featuresData } from './Feature/helpers';
import { useCommonStore } from '@/store';

import { ScFeaturesSection } from './styled';

export const FeaturesSection = () => {
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const features = useMemo(
    () => (isMobileDevice ? featuresData.slice(0, 3) : featuresData),
    [isMobileDevice]
  );

  return (
    <ScFeaturesSection>
      {features.map((feature) => (
        <FeatureCard {...feature} key={feature.text} />
      ))}
    </ScFeaturesSection>
  );
};
